/* 列傳選單每篇下方的武將小圖：每章的主角（play，可以操作）與其他登場武將（seen）
 * 由 tests/campaign_cast.cjs --write 從章節檔產生，不要手改。 */
// @ts-nocheck
export default {
  'sunjian-1': { play: ['sunjian'], seen: ['chengpu','hanzhong'] },
  'sunwu-3': { play: ['sunjian'], seen: ['zumao','xurong'] },
  'sunwu-4': { play: ['sunjian'], seen: ['chengpu','huaxiong'] },
  'sunwu-5': { play: ['sunce'], seen: ['chengpu'] },
  'sunwu-6': { play: ['sunce'], seen: ['taishici','chengpu'] },
  'sunwu-7': { play: ['taishici'], seen: ['sunce'] },
  'sunwu-8': { play: ['zhoutai'], seen: ['sunquan'] },
  'sunwu-9': { play: ['sunce'], seen: [] },
  'sunwu-10': { play: ['lingtong'], seen: ['ganning','dongxi','huangzu'] },
  'sunwu-11': { play: ['sunquan'], seen: ['zhouyu','lusu','zhangzhao','chengpu','huanggai','zhugeliang'] },
  'sunwu-12': { play: ['huanggai','handang'], seen: [] },
  'sunwu-14': { play: ['zhouyu'], seen: ['chengpu','huanggai','caocao'] },
  'sunwu-15': { play: ['sunquan'], seen: ['zhangliao','lingtong'] },
  'sunwu-16': { play: ['ganning'], seen: [] },
  'sunwu-17': { play: ['lvmeng'], seen: [] },
  'sunwu-18': { play: ['luxun'], seen: ['handang','xusheng','zhuran','liubei'] },
  'caocao-1': { play: ['caocao'], seen: [] },
  'caocao-2': { play: ['caocao','caohong'], seen: ['xurong'] },
  'caocao-3': { play: ['caocao'], seen: ['xiahoudun'] },
  'caocao-4': { play: ['caocao'], seen: ['zumao'] },
  'caocao-5': { play: ['dianwei'], seen: ['caocao'] },
  'caocao-6': { play: ['caocao'], seen: ['xiahoudun','lubu'] },
  'caocao-7': { play: ['zhangliao'], seen: ['guanyu','yanliang','wenchou'] },
  'caocao-8': { play: ['caocao'], seen: ['yanliang'] },
  'caocao-9': { play: ['zhangliao'], seen: ['yanliang'] },
  'caocao-10': { play: ['caocao'], seen: [] },
  'caocao-11': { play: ['xuchu'], seen: ['caocao','machao'] },
  'caocao-12': { play: ['xiahouyuan','caocao'], seen: ['huangzhong'] },
  'liubei-1': { play: ['liubei'], seen: ['guanyu','zhangfei'] },
  'liubei-2': { play: ['taishici','liubei'], seen: ['hanzhong'] },
  'liubei-3': { play: ['liubei'], seen: ['zhangfei'] },
  'liubei-4': { play: ['guanyu'], seen: ['zhangliao','yanliang'] },
  'liubei-5': { play: ['liubei'], seen: ['guanyu','zhangfei','zhugeliang'] },
  'liubei-6': { play: ['zhaoyun','zhangfei'], seen: [] },
  'liubei-7': { play: ['zhugeliang','liubei'], seen: ['sunquan','zhangfei'] },
  'liubei-8': { play: ['pangtong','liubei'], seen: ['huangzu'] },
  'liubei-9': { play: ['huangzhong'], seen: ['fazheng','xiahouyuan'] },
  'liubei-10': { play: ['zhaoyun'], seen: ['huangzhong'] },
  'liubei-11': { play: ['liubei'], seen: [] },
  'guanzhang-1': { play: ['zhangfei'], seen: ['yanyan'] },
  'guanzhang-2': { play: ['zhangfei'], seen: ['zhanghe'] },
  'guanzhang-3': { play: ['guanyu'], seen: [] },
  'guanzhang-4': { play: ['guanyu'], seen: ['pangde','yujin','guanping'] },
  'guanzhang-5': { play: ['guanyu'], seen: ['zhuran','guanping','zhaolei','panzhang'] },
  'zhaoyun-1': { play: ['zhaoyun'], seen: ['liubei','yujin','xiahoudun','lidian','zy-xiahoulan'] },
  'zhaoyun-2': { play: ['zhaoyun'], seen: ['zy-zhaofan'] },
  'zhaoyun-3': { play: ['zhaoyun'], seen: ['zhangfei'] },
  'zhaoyun-4': { play: ['zhaoyun'], seen: ['caozhen','zhugeliang','zy-dengzhi'] },
  'machao-1': { play: ['machao'], seen: ['pangde','zhongyao','mc-guoyuan','mc-gaogan'] },
  'machao-2a': { play: ['machao'], seen: ['xuhuang','mc-liangxing','mc-zhuling','caocao','xuchu'] },
  'machao-3a': { play: ['machao'], seen: ['caocao','xuchu','mc-hansui','mc-yangqiu','mc-likan','mc-chengyi','mc-liangxing'] },
  'machao-4': { play: ['machao'], seen: ['caoren','xiahouyuan','zhanghe','xuhuang','xuchu','pangde','mc-hansui','mc-chengyi','mc-likan','mc-yangqiu'] },
  'machao-5a': { play: ['machao'], seen: ['pangde','mc-jiangxu','mc-yangfu'] },
  'machao-6': { play: ['machao'], seen: [] },
  'xiahouyuan-1': { play: ['xiahouyuan'], seen: [] },
  'xiahouyuan-2': { play: ['xiahouyuan'], seen: ['yujin','changxi'] },
  'xiahouyuan-3': { play: ['xiahouyuan'], seen: ['zhanghe','machao'] },
  'xiahouyuan-4': { play: ['xiahouyuan'], seen: ['hansui'] },
  'xiahouyuan-5': { play: ['xiahouyuan'], seen: ['zhanghe','songjian'] },
  'simayi-1': { play: ['simayi'], seen: ['mengda'] },
  'simayi-2': { play: ['simayi'], seen: ['guohuai'] },
  'simayi-3': { play: ['simayi'], seen: ['niujin','huzun','beiyan','gongsunyuan'] },
  'simayi-4': { play: ['simayi'], seen: ['simashi'] },
  'zhouyu-1': { play: ['zhouyu'], seen: ['sunce','zy_fanneng','zy_yumi','zy_zhangying'] },
  'zhouyu-2': { play: ['zhouyu'], seen: ['chengpu','huanggai'] },
  'zhouyu-3': { play: ['zhouyu'], seen: ['lvmeng','ganning','chengpu','caoren'] },
  'zhouyu-4': { play: ['zhouyu'], seen: [] },
  'ganning-1': { play: ['ganning'], seen: ['huangzu','lingcao'] },
  'ganning-2': { play: ['ganning'], seen: ['zhouyu','lvmeng'] },
  'ganning-3': { play: ['ganning'], seen: ['lvmeng','zhuguang'] },
  'ganning-4': { play: ['ganning'], seen: ['lusu','guanyu'] },
  'luxun-1': { play: ['luxun'], seen: ['lx-feizhan'] },
  'luxun-2': { play: ['luxun'], seen: ['lx-fanyou','lx-xiejing','lx-zhanyan','lx-chenfeng','lx-wenbu','lx-dengkai'] },
  'luxun-3': { play: ['luxun'], seen: ['caoxiu','lx-zhuhuan','lx-quancong','lx-jiakui'] },
  'luxun-4': { play: ['luxun'], seen: ['lx-zhugejin'] },
  'taishici-1': { play: ['taishici'], seen: [] },
  'taishici-2': { play: ['taishici'], seen: ['sunce'] },
  'taishici-3': { play: ['taishici'], seen: ['sunce'] },
  'taishici-4': { play: ['taishici'], seen: ['tsc_liupan'] },
};
